<template>
  <div
    class="wf-flex wf-flex-wrap wf-justify-between wf-w-full wf-py-2 wf-items-center"
  >
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Event</span>
    <div class="wf-w-1/2">
      <select v-model="event" class="wf-w-full">
        <option :value="null">None</option>
        <option value="open-modal">Open Modal</option>
        <option value="close-modal">Close Modal</option>
      </select>
    </div>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      event: {
        get() {
          return this.elementContent.event
        },
        set(value) {
          this.addToObject(this.module, {event: value}, 'content', null, {}, true, this.parentModule)
        }
      }
    }
  })
</script>
